import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Mite silhouette uses the ★1 tier art. The active rendering for
// Paper Mite goes through TIERED_GLYPHS (see tieredGlyphs.ts) which
// routes ★2/★3 to the richer tier images extracted from
// assets/paper_mite_3tier.jpg.
export const Mite = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/mite-1.png" size={size} alt="mite" />
)
